export const UserOriginIcon = ({ className, size = 10, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size * 1.2} // Maintain aspect ratio (10x12)
        viewBox="0 0 10 12"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="5" cy="2.74219" r="2.5" fill="#899CBD" />
        <path
            d="M5 5.88086C2.17241 5.88086 0.421738 7.11482 0.0669784 9.21721C-0.00959982 9.67103 0.373096 10.0475 0.833333 10.0475H9.16667C9.6269 10.0475 10.0096 9.67103 9.93302 9.21721C9.57826 7.11482 7.82759 5.88086 5 5.88086Z"
            fill="#899CBD"
        />
    </svg>
)

export default UserOriginIcon
